/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './auth/login/login.component.ngfactory';
import * as i4 from './auth/logout/logout.component.ngfactory';
import * as i5 from './auth/recover-password/recover-password.component.ngfactory';
import * as i6 from './auth/reset-password/reset-password.component.ngfactory';
import * as i7 from '../../$$_gendir/node_modules/ngx-toastr/index.ngfactory';
import * as i8 from './app.component.ngfactory';
import * as i9 from '@angular/router';
import * as i10 from '@angular/common';
import * as i11 from 'ng2-daterangepicker/lib/daterangepicker/config.service';
import * as i12 from '@angular/forms';
import * as i13 from 'ngx-pagination';
import * as i14 from '@ngx-translate/core/src/translate.store';
import * as i15 from '@angular/common/http';
import * as i16 from '@ngx-translate/core/src/translate.loader';
import * as i17 from '../../app/core/factories/translate-loader.factory';
import * as i18 from '@ngx-translate/core/src/translate.compiler';
import * as i19 from '@ngx-translate/core/src/translate.parser';
import * as i20 from '@ngx-translate/core/src/missing-translation-handler';
import * as i21 from '@ngx-translate/core/src/translate.service';
import * as i22 from '../../app/shared/pipes/localized-date.pipe';
import * as i23 from '@angular/http';
import * as i24 from '../../app/core/services/api/auth-http.service';
import * as i25 from '../../app/auth/reset-password/reset-password.resolver';
import * as i26 from '@angular/platform-browser';
import * as i27 from '@angular/animations/browser';
import * as i28 from '@angular/platform-browser/animations';
import * as i29 from '@angular/animations';
import * as i30 from '@agm/core/utils/browser-globals';
import * as i31 from '@agm/core/services/maps-api-loader/maps-api-loader';
import * as i32 from '@agm/core/services/maps-api-loader/lazy-maps-api-loader';
import * as i33 from 'ngx-toastr';
import * as i34 from '../../app/core/services/authentication/refresh-token.service';
import * as i35 from '../../app/core/services/base/pending.service';
import * as i36 from '../../app/core/services/base/http.service';
import * as i37 from '../../app/core/services/base/http-service.factory';
import * as i38 from '../../app/core/services/api/check-http.service';
import * as i39 from '../../app/core/services/api/company-http.service';
import * as i40 from '../../app/core/services/api/employee-http.service';
import * as i41 from '../../app/core/services/api/notification-http.service';
import * as i42 from '../../app/core/services/visual/toaster.service';
import * as i43 from '../../app/core/services/api/user-http.service';
import * as i44 from '../../app/core/services/validation/validation.service';
import * as i45 from '../../app/core/guards/admin.guard';
import * as i46 from '../../app/core/guards/logged-in.guard';
import * as i47 from '../../app/core/guards/not-logged-in.guard';
import * as i48 from '../../app/auth/login/login.component';
import * as i49 from '../../app/auth/logout/logout.component';
import * as i50 from '../../app/auth/recover-password/recover-password.component';
import * as i51 from '../../app/auth/reset-password/reset-password.component';
import * as i52 from '../../app/app-routing.module';
import * as i53 from '../../app/auth/auth-routing.module';
import * as i54 from 'ng2-daterangepicker/lib/daterangepicker/daterangepicker.module';
import * as i55 from 'ngx-boot-modal/modal/modal.module';
import * as i56 from '@ultimate/ngxerrors/src/ngxerrors.module';
import * as i57 from 'ng-select/index';
import * as i58 from '@ngx-translate/core/index';
import * as i59 from '../../app/shared/shared.module';
import * as i60 from '../../app/auth/auth.module';
import * as i61 from '@agm/core/core.module';
import * as i62 from '../../app/core/core.module';
import * as i63 from '../../app/core/config/google-maps-config';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.LoginComponentNgFactory,i4.LogoutComponentNgFactory,i5.RecoverPasswordComponentNgFactory,
              i6.ResetPasswordComponentNgFactory,i7.ToastNgFactory,i8.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i9.ActivatedRoute,
          i9.ɵf,[i9.Router]),i0.ɵmpd(4608,i9.NoPreloading,i9.NoPreloading,([] as any[])),
          i0.ɵmpd(6144,i9.PreloadingStrategy,(null as any),[i9.NoPreloading]),i0.ɵmpd(135680,
              i9.RouterPreloader,i9.RouterPreloader,[i9.Router,i0.NgModuleFactoryLoader,
                  i0.Compiler,i0.Injector,i9.PreloadingStrategy]),i0.ɵmpd(4608,i9.PreloadAllModules,
              i9.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i9.ROUTER_INITIALIZER,
              i9.ɵi,[i9.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i9.ROUTER_INITIALIZER]),i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),
          i0.ɵmpd(4608,i10.NgLocalization,i10.NgLocaleLocalization,[i0.LOCALE_ID]),
          i0.ɵmpd(4608,i11.DaterangepickerConfig,i11.DaterangepickerConfig,([] as any[])),
          i0.ɵmpd(4608,i12.ɵi,i12.ɵi,([] as any[])),i0.ɵmpd(4608,i12.FormBuilder,i12.FormBuilder,
              ([] as any[])),i0.ɵmpd(4608,i13.PaginationService,i13.PaginationService,
              ([] as any[])),i0.ɵmpd(4608,i14.TranslateStore,i14.TranslateStore,([] as any[])),
          i0.ɵmpd(4608,i15.ɵd,i15.ɵd,([] as any[])),i0.ɵmpd(6144,i15.XhrFactory,(null as any),
              [i15.ɵd]),i0.ɵmpd(4608,i15.HttpXhrBackend,i15.HttpXhrBackend,[i15.XhrFactory]),
          i0.ɵmpd(6144,i15.HttpBackend,(null as any),[i15.HttpXhrBackend]),i0.ɵmpd(4608,
              i15.HttpXsrfTokenExtractor,i15.ɵg,[i10.DOCUMENT,i0.PLATFORM_ID,i15.ɵe]),
          i0.ɵmpd(4608,i15.ɵh,i15.ɵh,[i15.HttpXsrfTokenExtractor,i15.ɵf]),i0.ɵmpd(5120,
              i15.HTTP_INTERCEPTORS,(p0_0:any) => {
                return [p0_0];
              },[i15.ɵh]),i0.ɵmpd(5120,i15.HttpHandler,i15.ɵinterceptingHandler,[i15.HttpBackend,
              [2,i15.HTTP_INTERCEPTORS]]),i0.ɵmpd(4608,i15.HttpClient,i15.HttpClient,
              [i15.HttpHandler]),i0.ɵmpd(5120,i16.TranslateLoader,i17.createTranslateLoader,
              [i15.HttpClient]),i0.ɵmpd(4608,i18.TranslateCompiler,i18.TranslateFakeCompiler,
              ([] as any[])),i0.ɵmpd(4608,i19.TranslateParser,i19.TranslateDefaultParser,
              ([] as any[])),i0.ɵmpd(4608,i20.MissingTranslationHandler,i20.FakeMissingTranslationHandler,
              ([] as any[])),i0.ɵmpd(4608,i21.TranslateService,i21.TranslateService,
              [i14.TranslateStore,i16.TranslateLoader,i18.TranslateCompiler,i19.TranslateParser,
                  i20.MissingTranslationHandler,i21.USE_DEFAULT_LANG,i21.USE_STORE]),
          i0.ɵmpd(4608,i22.LocalizedDatePipe,i22.LocalizedDatePipe,[i21.TranslateService]),
          i0.ɵmpd(4608,i23.BrowserXhr,i23.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i23.ResponseOptions,
              i23.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i23.XSRFStrategy,
              i23.ɵb,([] as any[])),i0.ɵmpd(4608,i23.XHRBackend,i23.XHRBackend,[i23.BrowserXhr,
              i23.ResponseOptions,i23.XSRFStrategy]),i0.ɵmpd(4608,i23.RequestOptions,
              i23.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i23.Http,i23.ɵc,[i23.XHRBackend,
              i23.RequestOptions]),i0.ɵmpd(4608,i24.AuthHttpService,i24.AuthHttpService,
              [i23.Http]),i0.ɵmpd(4608,i25.ResetPasswordResolver,i25.ResetPasswordResolver,
              [i24.AuthHttpService]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
              i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
              i0.ɵl,([] as any[])),i0.ɵmpd(4608,i26.DomSanitizer,i26.ɵe,[i10.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i26.DomSanitizer]),i0.ɵmpd(4608,
              i26.HAMMER_GESTURE_CONFIG,i26.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i26.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i26.ɵDomEventsPlugin(p0_0),new i26.ɵKeyEventsPlugin(p1_0),
                    new i26.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i10.DOCUMENT,i10.DOCUMENT,i10.DOCUMENT,i26.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i26.EventManager,i26.EventManager,[i26.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i26.ɵDomSharedStylesHost,i26.ɵDomSharedStylesHost,
              [i10.DOCUMENT]),i0.ɵmpd(4608,i26.ɵDomRendererFactory2,i26.ɵDomRendererFactory2,
              [i26.EventManager,i26.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i27.AnimationDriver,
              i28.ɵc,([] as any[])),i0.ɵmpd(5120,i27.ɵAnimationStyleNormalizer,i28.ɵd,
              ([] as any[])),i0.ɵmpd(4608,i27.ɵAnimationEngine,i28.ɵb,[i27.AnimationDriver,
              i27.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i28.ɵe,
              [i26.ɵDomRendererFactory2,i27.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i26.ɵSharedStylesHost,(null as any),[i26.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i26.Meta,i26.Meta,
              [i10.DOCUMENT]),i0.ɵmpd(4608,i26.Title,i26.Title,[i10.DOCUMENT]),i0.ɵmpd(4608,
              i29.AnimationBuilder,i28.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
                  i26.DOCUMENT]),i0.ɵmpd(4608,i30.WindowRef,i30.WindowRef,([] as any[])),
          i0.ɵmpd(4608,i30.DocumentRef,i30.DocumentRef,([] as any[])),i0.ɵmpd(4608,
              i31.MapsAPILoader,i32.LazyMapsAPILoader,[i32.LAZY_MAPS_API_CONFIG,i30.WindowRef,
                  i30.DocumentRef]),i0.ɵmpd(4608,i33.OverlayContainer,i33.OverlayContainer,
              ([] as any[])),i0.ɵmpd(4608,i33.Overlay,i33.Overlay,[i33.OverlayContainer,
              i0.ComponentFactoryResolver,i0.ApplicationRef]),i0.ɵmpd(4608,i33.ToastrService,
              i33.ToastrService,[i33.TOAST_CONFIG,i33.Overlay,i0.Injector,i26.DomSanitizer]),
          i0.ɵmpd(4608,i34.RefreshTokenService,i34.RefreshTokenService,[i24.AuthHttpService,
              i9.Router]),i0.ɵmpd(4608,i35.PendingService,i35.PendingService,([] as any[])),
          i0.ɵmpd(5120,i36.HttpService,i37.httpServiceFactory,[i23.XHRBackend,i23.RequestOptions,
              i9.Router,i34.RefreshTokenService,i35.PendingService]),i0.ɵmpd(4608,
              i38.CheckHttpService,i38.CheckHttpService,[i36.HttpService]),i0.ɵmpd(4608,
              i39.CompanyHttpService,i39.CompanyHttpService,[i36.HttpService]),i0.ɵmpd(4608,
              i40.EmployeeHttpService,i40.EmployeeHttpService,[i36.HttpService]),i0.ɵmpd(4608,
              i41.NotificationHttpService,i41.NotificationHttpService,[i36.HttpService]),
          i0.ɵmpd(4608,i42.ToasterService,i42.ToasterService,[i33.ToastrService,i21.TranslateService]),
          i0.ɵmpd(4608,i43.UserHttpService,i43.UserHttpService,[i36.HttpService]),
          i0.ɵmpd(4608,i44.ValidationService,i44.ValidationService,[i42.ToasterService,
              i21.TranslateService]),i0.ɵmpd(4608,i45.AdminGuard,i45.AdminGuard,([] as any[])),
          i0.ɵmpd(4608,i46.LoggedInGuard,i46.LoggedInGuard,[i9.Router]),i0.ɵmpd(4608,
              i47.NotLoggedInGuard,i47.NotLoggedInGuard,[i9.Router]),i0.ɵmpd(1024,
              i9.ɵa,i9.ɵd,[[3,i9.Router]]),i0.ɵmpd(1024,i0.ErrorHandler,i26.ɵa,([] as any[])),
          i0.ɵmpd(512,i9.ɵg,i9.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i9.ɵb()];
          },([] as any[])),i0.ɵmpd(1024,i0.APP_INITIALIZER,(p0_0:any,p1_0:any,p1_1:any) => {
            return [i9.ɵh(p0_0),i26.ɵc(p1_0,p1_1)];
          },[i9.ɵg,[2,i26.NgProbeToken],[2,i0.NgProbeToken]]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i9.UrlSerializer,i9.DefaultUrlSerializer,([] as any[])),
          i0.ɵmpd(512,i9.ChildrenOutletContexts,i9.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(256,i9.ROUTER_CONFIGURATION,{},([] as any[])),i0.ɵmpd(1024,i10.LocationStrategy,
              i9.ɵc,[i10.PlatformLocation,[2,i10.APP_BASE_HREF],i9.ROUTER_CONFIGURATION]),
          i0.ɵmpd(512,i10.Location,i10.Location,[i10.LocationStrategy]),i0.ɵmpd(512,
              i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i9.ROUTES,() => {
            return [[{path:'',loadChildren:'./dashboard/dashboard.module#DashboardModule'}],
                [{path:'login',component:i48.LoginComponent,canActivate:[i47.NotLoggedInGuard]},
                    {path:'logout',component:i49.LogoutComponent,canActivate:[i46.LoggedInGuard]},
                    {path:'recover-password',component:i50.RecoverPasswordComponent,
                        canActivate:[i47.NotLoggedInGuard]},{path:'reset-password/:hash',
                        component:i51.ResetPasswordComponent,canActivate:[i47.NotLoggedInGuard],
                        resolve:{resetPassword:i25.ResetPasswordResolver}}]];
          },([] as any[])),i0.ɵmpd(1024,i9.Router,i9.ɵe,[i0.ApplicationRef,i9.UrlSerializer,
              i9.ChildrenOutletContexts,i10.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i9.ROUTES,i9.ROUTER_CONFIGURATION,[2,i9.UrlHandlingStrategy],
              [2,i9.RouteReuseStrategy]]),i0.ɵmpd(512,i9.RouterModule,i9.RouterModule,
              [[2,i9.ɵa],[2,i9.Router]]),i0.ɵmpd(512,i52.AppRoutingModule,i52.AppRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i53.AuthRoutingModule,i53.AuthRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i10.CommonModule,i10.CommonModule,([] as any[])),
          i0.ɵmpd(512,i54.Daterangepicker,i54.Daterangepicker,([] as any[])),i0.ɵmpd(512,
              i12.ɵba,i12.ɵba,([] as any[])),i0.ɵmpd(512,i12.FormsModule,i12.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i55.ModalModule,i55.ModalModule,([] as any[])),
          i0.ɵmpd(512,i56.NgxErrorsModule,i56.NgxErrorsModule,([] as any[])),i0.ɵmpd(512,
              i12.ReactiveFormsModule,i12.ReactiveFormsModule,([] as any[])),i0.ɵmpd(512,
              i57.SelectModule,i57.SelectModule,([] as any[])),i0.ɵmpd(512,i58.TranslateModule,
              i58.TranslateModule,([] as any[])),i0.ɵmpd(512,i13.NgxPaginationModule,
              i13.NgxPaginationModule,([] as any[])),i0.ɵmpd(512,i59.SharedModule,
              i59.SharedModule,([] as any[])),i0.ɵmpd(512,i60.AuthModule,i60.AuthModule,
              ([] as any[])),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,
              [i0.ApplicationRef]),i0.ɵmpd(512,i26.BrowserModule,i26.BrowserModule,
              [[3,i26.BrowserModule]]),i0.ɵmpd(512,i28.BrowserAnimationsModule,i28.BrowserAnimationsModule,
              ([] as any[])),i0.ɵmpd(512,i61.AgmCoreModule,i61.AgmCoreModule,([] as any[])),
          i0.ɵmpd(512,i23.HttpModule,i23.HttpModule,([] as any[])),i0.ɵmpd(512,i15.HttpClientXsrfModule,
              i15.HttpClientXsrfModule,([] as any[])),i0.ɵmpd(512,i15.HttpClientModule,
              i15.HttpClientModule,([] as any[])),i0.ɵmpd(512,i33.ToastrModule,i33.ToastrModule,
              [[3,i33.ToastrModule]]),i0.ɵmpd(512,i62.CoreModule,i62.CoreModule,([] as any[])),
          i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[])),i0.ɵmpd(256,i15.ɵe,
              'XSRF-TOKEN',([] as any[])),i0.ɵmpd(256,i15.ɵf,'X-XSRF-TOKEN',([] as any[])),
          i0.ɵmpd(256,i21.USE_DEFAULT_LANG,(undefined as any),([] as any[])),i0.ɵmpd(256,
              i21.USE_STORE,(undefined as any),([] as any[])),i0.ɵmpd(512,i32.LAZY_MAPS_API_CONFIG,
              i63.GoogleMapsConfig,([] as any[])),i0.ɵmpd(256,i33.TOAST_CONFIG,{timeOut:2000,
              positionClass:'toast-top-center',preventDuplicates:false},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9sYW50YWdvLWFwcC9sYW50YWdvLWFwcC1kZW1vL3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/$$_gendir/app/app.module.ngfactory.ts